<template>
  <div>
    <template v-if="this.data != null">
      <keep-alive>
        <v-tabs show-arrows="always" v-model="tabs" background-color="transparent">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab> Výkonové a proudové omezení </v-tab>
          <v-tab> Synchronizace se síťí </v-tab>
          <v-tab> Omezení činného výkonu P(U) </v-tab>
          <v-tab> Omezení činného výkonu P(f) </v-tab>
          <v-tab> Podpora sítě </v-tab>
          <v-tab> Podpora sítě 2 </v-tab>
          <v-tab> Tabulkový pohled </v-tab>

          <v-tab-item class="ma-2">
            <v-row class="ma-1">
              <v-col cols="12" class="ma-2 text-caption">
                <i>
                  Plocha ohraničená modrou barvou v grafu znázorňuje povinnou oblast podpory sítě. Tato oblast může být různá pro různé distribuční sítě v jiných zemí. Celkový zdánlivý výkon nesmí přesáhnout hodnotu definovanou křivkou fialové barvy i za cenu snížení činného výkonu. Kromě výkonového
                  omezení je zde i omezení proudové. <br /><br />
                  Kompenzace jalového výkonu je aktivována na základě předpisu provozovatele distribuční soustavy podle místa připojení (konstantní Q, Q(U), konstantní učiník nebo učiník(P)) a v případě některých funkcí podmínky v síťi (Q(U)).
                  <br />
                  P... činný výkon<br />
                  Q... jalový výkon<br />
                  U... napětí v distribuční síťi<br />
                  Činný výkon může být snížen na základě dalších podmínek v síťi jako je například vysoká frekvence nebo vysoké napětí. <br />
                </i>
                <br />
              </v-col>
              <v-col cols="12" md="6" :class="$vuetify.breakpoint.mdAndDown ? 'text-start' : 'text-center'">
                <h3>
                  <i>Aktuální výkon z/do střídače: </i>
                </h3>
                <b v-for="item in data.inverter" :key="item.index + 'A'">
                  <h4>{{ item.activePower }} W {{ item.reactivePower }} VAr {{ item.apparentPower }} VA</h4>
                  <h6>
                    <i>({{ item.u }} V {{ item.i }} A {{ item.phase }} °)</i>
                  </h6>
                </b>
              </v-col>
              <v-col cols="12" md="6" :class="$vuetify.breakpoint.mdAndDown ? 'text-start' : 'text-center'">
                <h3>
                  <i>Aktuální výkon z/do distribuční sítě: </i>
                </h3>
                <b v-for="item in data.grid" :key="item.index + 'B'">
                  <h4>{{ item.activePower }} W {{ item.reactivePower }} VAr {{ item.apparentPower }} VA</h4>
                  <h6>
                    <i>({{ item.u }} V {{ item.i }} A {{ item.phase }} °)</i>
                  </h6>
                </b>
              </v-col>

              <v-col cols="12" md="6">
                <v-row no-gutters>
                  <v-col cols="12">
                    <h4 class="text-center">Požadavky na dodávku / odběr jalového výkonu při Un</h4>
                  </v-col>

                  <v-col cols="12">
                    <template v-if="parameters != null">
                      <ApexScatterChartMixed
                        :chart="'A'"
                        :Smax="Smax"
                        :Pmax="Pmax"
                        :Qmax="Qmax"
                        :QPmax="QPmax"
                        :powerFactor="powerFactor"
                        :P1="data.inverter.length > 0 ? Math.abs(data.inverter[0].activePower) : 0"
                        :P2="data.inverter.length > 1 ? Math.abs(data.inverter[1].activePower) : 0"
                        :P3="data.inverter.length > 2 ? Math.abs(data.inverter[2].activePower) : 0"
                        :Q1="data.inverter.length > 0 ? data.inverter[0].reactivePower : 0"
                        :Q2="data.inverter.length > 1 ? data.inverter[1].reactivePower : 0"
                        :Q3="data.inverter.length > 2 ? data.inverter[2].reactivePower : 0"
                        :dark="$vuetify.theme.dark"
                      />
                    </template>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="6">
                <v-row no-gutters>
                  <v-col cols="12">
                    <h4 class="text-center">Požadavky pro napětí odlišná od jmenovitého (jalový výkon výrobního modulu pro P=Pd)</h4>
                  </v-col>

                  <v-col cols="12">
                    <template v-if="parameters != null">
                      <ApexScatterChartMixed
                        :chart="'B'"
                        :Smax="Smax"
                        :Pmax="Pmax"
                        :Qmax="Qmax"
                        :QPmax="QPmax"
                        :powerFactor="powerFactor"
                        :P1="data.inverter.length > 0 ? data.inverter[0].activePower : 0"
                        :P2="data.inverter.length > 1 ? data.inverter[1].activePower : 0"
                        :P3="data.inverter.length > 2 ? data.inverter[2].activePower : 0"
                        :Q1="data.inverter.length > 0 ? data.inverter[0].reactivePower : 0"
                        :Q2="data.inverter.length > 1 ? data.inverter[1].reactivePower : 0"
                        :Q3="data.inverter.length > 2 ? data.inverter[2].reactivePower : 0"
                        :U1="data.grid.length > 0 ? data.grid[0].u : 0"
                        :U2="data.grid.length > 1 ? data.grid[1].u : 0"
                        :U3="data.grid.length > 2 ? data.grid[2].u : 0"
                        :dark="$vuetify.theme.dark"
                      />
                    </template>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item class="ma-2">
            <v-row class="ma-1">
              <v-col cols="12" class="ma-2 text-caption">
                <i>Připojovací podmínky se mohou lišit podle toho zda střídač zahajuje generování nebo startuje za normálních okolností nebo zda-li se střídač připojuje po vybavení ochrany rozhraní </i>
                <br />
              </v-col>
              <v-col cols="12" class="ma-2">
                <h4><i>Aktuální připojovací podmínky: </i></h4>
                <br />
                Výkonové omezení: <b> {{ data.synchronization.fPowerLimit }} W </b> <br />
                Gradient (výkon / min): <b> {{ data.synchronization.fGradient }} % Pn/min </b><br />
                Pozorovací čas: <b> {{ data.synchronization.u32ObservationTime }} s </b><br />
                Frekvence musí být v rozmezí:
                <b>{{ data.synchronization.fLowerFrequency }} Hz až {{ data.synchronization.fUpperFrequency }} Hz </b>
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp; Aktuální frekvence v síti: <b>{{ data.grid[0].f }} Hz </b> <br />
                Napětí musí být v rozmezí: <b>{{ data.synchronization.fLowerVoltage }} V až {{ data.synchronization.fUpperVoltage }} V </b>
                <br />

                &nbsp;&nbsp;&nbsp;&nbsp; Aktuální napětí v síťi: <b v-for="item in data.grid" :key="item.index + 'C'"> {{ item.u }} V </b>
                <br />
                <br />
                Doba, kdy síť je v intervalech ochrany rozhraní: <b> {{ GridPresent }} s </b><br />
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item class="ma-2">
            <v-row class="ma-1">
              <v-col cols="12" class="ma-2 text-caption">
                <i>
                  <b> P(U) </b>
                  Všechny výrobny na hladině nn musí být vybaveny s funkcí pro řízení napětí činným výkonem P(U). Důvodem je snaha zabránit odpojení výroben nadpěťovými ochranami. Funkce může být v dané lokalitě aktivována / deaktivována. <br />
                </i>
                <br />
              </v-col>

              <v-col cols="12" md="6" class="text-caption">
                <v-row>
                  <v-col cols="5" align="center">
                    <template v-if="onGridConfigBits.EN_P_f_UUpper === true">
                      <v-chip small color="green" outlined><b>P(U) - Funkce povolena!</b> </v-chip>
                    </template>
                    <template v-else>
                      <v-chip small color="red" outlined><b> P(U) - Funkce není povolena!</b> </v-chip>
                    </template>
                  </v-col>
                  <v-col cols="7">
                    <i>
                      Výkonový limit: <b v-for="item in data.PLimits" :key="item.index + 'D'"> {{ item.fPDischargefU }} W </b> <br />
                      Napětí: <b v-for="item in data.grid" :key="item.index + 'E'"> {{ item.u }} V </b>
                    </i>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <h4 class="text-center">P(U) - Snížení činného výkonu závislé na napětí</h4>
                      </v-col>

                      <v-col cols="12">
                        <template v-if="parameters != null">
                          <ApexScatterChartMixed
                            :chart="'C'"
                            :Smax="Smax"
                            :Pmax="Pmax"
                            :Qmax="Qmax"
                            :QPmax="QPmax"
                            :powerFactor="powerFactor"
                            :v5="v5"
                            :v6="v6"
                            :v7="v7"
                            :P1="data.inverter.length > 0 ? data.inverter[0].activePower : 0"
                            :P2="data.inverter.length > 1 ? data.inverter[1].activePower : 0"
                            :P3="data.inverter.length > 2 ? data.inverter[2].activePower : 0"
                            :U1="data.grid.length > 0 ? data.grid[0].u : 0"
                            :U2="data.grid.length > 1 ? data.grid[1].u : 0"
                            :U3="data.grid.length > 2 ? data.grid[2].u : 0"
                            :P1fU1="data.PLimits.length > 0 ? data.PLimits[0].fPDischargefU : 0"
                            :P2fU2="data.PLimits.length > 1 ? data.PLimits[1].fPDischargefU : 0"
                            :P3fU3="data.PLimits.length > 2 ? data.PLimits[2].fPDischargefU : 0"
                            :activeMinimumPowerPU="activeMinimumPowerPU"
                            :dark="$vuetify.theme.dark"
                          /> </template
                      ></v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item class="ma-2">
            <v-row class="ma-1">
              <v-col cols="12" class="ma-2 text-caption">
                <i>
                  b) Odezvy činného výkonu na základě podfrekvence <br />
                  a) Odezvy činného výkonu na základě nadfrekvence <br />
                </i>
                <br />
              </v-col>

              <v-col cols="12" md="6" class="text-caption">
                <v-row>
                  <v-col cols="7">
                    <template v-if="onGridConfigBits.EN_P_f_fLower === true">
                      <v-chip small class="ma-1" color="green" outlined><b>P(f) - Podfrekvence - Funkce povolena!</b> </v-chip>
                    </template>
                    <template v-else>
                      <v-chip small class="ma-1" color="red" outlined><b> P(f) - Podfrekvence - Funkce není povolena!</b> </v-chip>
                    </template>
                  </v-col>

                  <v-col cols="5">
                    <i>
                      Požadavek / Limit:
                      <b v-for="item in data.PLimits" :key="item.index + 'G'"> {{ item.fPfFrequencyLower }} W </b> <br />
                    </i>
                  </v-col>

                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <h4 class="text-center">Odezva činného výkonu při podfrekvenci</h4>
                        V případě, že dojde k aktivaci funkce <br />
                        - Kladný výkon znamená požadavek generování do distribuční sítě <br />
                        - Záporný výkon znamená limitace nabíjení z distribuční sítě <br />
                      </v-col>

                      <v-col cols="12">
                        <template v-if="parameters != null">
                          <ApexScatterChartMixed
                            :chart="'H'"
                            :Smax="Smax"
                            :Pmax="Pmax"
                            :Qmax="Qmax"
                            :QPmax="QPmax"
                            :powerFactor="powerFactor"
                            :P1="data.inverter.length > 0 ? data.inverter[0].activePower : 0"
                            :P2="data.inverter.length > 1 ? data.inverter[1].activePower : 0"
                            :P3="data.inverter.length > 2 ? data.inverter[2].activePower : 0"
                            :U1="data.grid.length > 0 ? data.grid[0].u : 0"
                            :U2="data.grid.length > 1 ? data.grid[1].u : 0"
                            :U3="data.grid.length > 2 ? data.grid[2].u : 0"
                            :frequency="data.grid[0].f"
                            :frequencyMin="frequencyMin"
                            :frequencyMax="frequencyMax"
                            :P_HF_ThresholdFreq="P_HF_ThresholdFreq"
                            :P_LF_ThresholdFreq="P_LF_ThresholdFreq"
                            :P_LF_StopFreq="P_LF_StopFreq"
                            :P_LF_Gradient="P_LF_Gradient"
                            :P_LF_Delay="P_LF_Delay"
                            :P_LF_P1="data.PLimits.length > 0 ? data.PLimits[0].fPfFrequencyLower : 0"
                            :P_LF_P2="data.PLimits.length > 1 ? data.PLimits[1].fPfFrequencyLower : 0"
                            :P_LF_P3="data.PLimits.length > 2 ? data.PLimits[2].fPfFrequencyLower : 0"
                            :EN_P_f_f_Gradient="onGridConfigBits.EN_P_f_f_Gradient"
                            :dark="$vuetify.theme.dark"
                          />
                        </template>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="6" class="text-caption">
                <v-row>
                  <v-col cols="7">
                    <template v-if="onGridConfigBits.EN_P_f_fUpper === true">
                      <v-chip small class="ma-1" color="green" outlined><b>P(f) - Nadfrekvence - Funkce povolena!</b> </v-chip>
                    </template>
                    <template v-else>
                      <v-chip small class="ma-1" color="red" outlined><b> P(f) - Nadfrekvence - Funkce není povolena!</b> </v-chip>
                    </template>
                  </v-col>

                  <v-col cols="5">
                    <i>
                      Požadavek / Limit:
                      <b v-for="item in data.PLimits" :key="item.index + 'F'"> {{ item.fPfFrequencyUpper }} W </b> <br />
                    </i>
                  </v-col>

                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <h4 class="text-center">Odezva činného výkonu při nadfrekvenci</h4>
                        V případě, že dojde k aktivaci funkce <br />
                        - Kladný výkon znamená limitace generování do distribuční sítě <br />
                        - Záporný výkon znamená požadavek nabíjení z distribuční sítě <br />
                      </v-col>

                      <v-col cols="12">
                        <template v-if="parameters != null">
                          <ApexScatterChartMixed
                            :chart="'G'"
                            :Smax="Smax"
                            :Pmax="Pmax"
                            :Qmax="Qmax"
                            :QPmax="QPmax"
                            :powerFactor="powerFactor"
                            :P1="data.inverter.length > 0 ? data.inverter[0].activePower : 0"
                            :P2="data.inverter.length > 1 ? data.inverter[1].activePower : 0"
                            :P3="data.inverter.length > 2 ? data.inverter[2].activePower : 0"
                            :U1="data.grid.length > 0 ? data.grid[0].u : 0"
                            :U2="data.grid.length > 1 ? data.grid[1].u : 0"
                            :U3="data.grid.length > 2 ? data.grid[2].u : 0"
                            :frequency="data.grid[0].f"
                            :frequencyMin="frequencyMin"
                            :frequencyMax="frequencyMax"
                            :P_LF_ThresholdFreq="P_LF_ThresholdFreq"
                            :P_HF_ThresholdFreq="P_HF_ThresholdFreq"
                            :P_HF_StopFreq="P_HF_StopFreq"
                            :P_HF_Gradient="P_HF_Gradient"
                            :P_HF_Delay="P_HF_Delay"
                            :P_HF_StopFreq2="P_HF_StopFreq2"
                            :P_HF_DeactivationTime="P_HF_DeactivationTime"
                            :P_HF_P1Limit="data.PLimits.length > 0 ? data.PLimits[0].fPfFrequencyUpper : 0"
                            :P_HF_P2Limit="data.PLimits.length > 1 ? data.PLimits[1].fPfFrequencyUpper : 0"
                            :P_HF_P3Limit="data.PLimits.length > 2 ? data.PLimits[2].fPfFrequencyUpper : 0"
                            :P_HF_P1Frozen="data.others.length > 0 ? data.others[0].fPfFrequencyUpperFrozenPower : 0"
                            :P_HF_P2Frozen="data.others.length > 1 ? data.others[1].fPfFrequencyUpperFrozenPower : 0"
                            :P_HF_P3Frozen="data.others.length > 2 ? data.others[2].fPfFrequencyUpperFrozenPower : 0"
                            :P_HF_P1Reference="data.others.length > 0 ? data.others[0].fPfFrequencyUpperReferencePower : 0"
                            :P_HF_P2Reference="data.others.length > 1 ? data.others[1].fPfFrequencyUpperReferencePower : 0"
                            :P_HF_P3Reference="data.others.length > 2 ? data.others[2].fPfFrequencyUpperReferencePower : 0"
                            :EN_P_f_f_Gradient="onGridConfigBits.EN_P_f_f_Gradient"
                            :dark="$vuetify.theme.dark"
                          />
                        </template>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item class="ma-2">
            <v-row dense class="ma-1">
              <v-col cols="12" class="ma-2 text-caption">
                <i>
                  Tam, kde je potřeba k příspěvku regulaci napětí určí distributor. Pouze jeden z režimů může být aktivní v jeden okamžik. Režimy jsou následující: a) konstantní jalový výkon
                  <b>Q = konst. </b>, b) jalový výkon dle napětí <b>Q(U)</b>, c) konstantní učiník <b>cos &phi; = konst</b>, a d) učiník je funkcí činného výkonu <b>cos &phi; (P)</b>. <br /><br />
                  Aktuálně nastavené chování EESS:
                  <b> Nominální účiník {{ powerFactor }} <br /> </b>
                  Aktuální stav fází:
                  <b>
                    <i> | Fáze 1: {{ data.state.length > 0 ? (data.state[0].i8QDirection == 1 ? "Vedení sítě" : "Zpoždování vůči síťi") : "Vedení sítě" }} </i>
                    <i> | Fáze 2: {{ data.state.length > 1 ? (data.state[1].i8QDirection == 1 ? "Vedení sítě" : "Zpoždování vůči síťi") : "Vedení sítě" }} </i>
                    <i> | Fáze 3: {{ data.state.length > 2 ? (data.state[2].i8QDirection == 1 ? "Vedení sítě" : "Zpoždování vůči síťi") : "Vedení sítě" }} | </i>
                  </b>
                  <br />
                </i>
                <br />
              </v-col>

              <v-col cols="12" md="6" class="text-caption">
                <v-row dense>
                  <v-col cols="5" align="center">
                    <template v-if="onGridConfigBits.EN_Q_f_U === true">
                      <v-chip small color="green" outlined><b>Q(U) - Funkce aktivována!</b> </v-chip>
                    </template>
                    <template v-else>
                      <v-chip small color="red" outlined><b> Q(U) - Funkce není povolena!</b> </v-chip>
                    </template>
                  </v-col>
                  <v-col cols="7">
                    <i>
                      Jalový výkon:
                      <b> {{ data.state.length > 0 ? (data.state[0].i8QDirection === 1 ? data.QLimits[0].fQfU + "VAr" : "-" + data.QLimits[0].fQfU + "VAr") : "" }} </b>
                      <b> {{ data.state.length > 1 ? (data.state[1].i8QDirection === 1 ? data.QLimits[1].fQfU + "VAr" : "-" + data.QLimits[1].fQfU + "VAr") : "" }} </b>
                      <b> {{ data.state.length > 2 ? (data.state[2].i8QDirection === 1 ? data.QLimits[2].fQfU + "VAr" : "-" + data.QLimits[2].fQfU + "VAr") : "" }} </b> <br />

                      Napětí: <b v-for="item in data.grid" :key="item.index + 'I'"> {{ item.u }} V </b>
                    </i>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <h4 class="text-center">Q(U) - Jalový výkon závislý na napětí</h4>
                      </v-col>

                      <v-col cols="12">
                        <template v-if="parameters != null">
                          <ApexScatterChartMixed
                            :chart="'D'"
                            :Smax="Smax"
                            :Pmax="Pmax"
                            :Qmax="Qmax"
                            :QPmax="QPmax"
                            :powerFactor="powerFactor"
                            :v1="v1"
                            :v2="v2"
                            :v3="v3"
                            :v4="v4"
                            :y1="y1"
                            :y2="y2"
                            :y3="y3"
                            :y4="y4"
                            :U1="data.grid.length > 0 ? data.grid[0].u : 0"
                            :U2="data.grid.length > 1 ? data.grid[1].u : 0"
                            :U3="data.grid.length > 2 ? data.grid[2].u : 0"
                            :Q1fU1="data.QLimits.length > 0 ? data.QLimits[0].fQfU : 0"
                            :Q2fU2="data.QLimits.length > 1 ? data.QLimits[1].fQfU : 0"
                            :Q3fU3="data.QLimits.length > 2 ? data.QLimits[2].fQfU : 0"
                            :directionP1="data.state.length > 0 ? data.state[0].i8QDirection : 0"
                            :directionP2="data.state.length > 1 ? data.state[1].i8QDirection : 0"
                            :directionP3="data.state.length > 2 ? data.state[2].i8QDirection : 0"
                            :dark="$vuetify.theme.dark"
                          />
                        </template>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="6" class="text-caption">
                <v-row dense>
                  <v-col cols="5" align="center">
                    <template v-if="onGridConfigBits.EN_Q_f_AdaptivePF === true">
                      <v-chip small color="green" outlined><b>cos &phi; (P) - Funkce aktivována!</b> </v-chip>
                    </template>
                    <template v-else>
                      <v-chip small color="red" outlined><b> cos &phi; (P) - Funkce není povolena!</b> </v-chip>
                    </template>
                  </v-col>
                  <v-col cols="7">
                    <i>
                      Jalový výkon: <b v-for="item in data.QLimits" :key="item.index + 'J'"> {{ item.fQCosPhiP }} VAr </b> Činný výkon: <b v-for="item in data.inverter" :key="item.index + 'K'"> {{ item.activePower }} W </b> <br />
                      Aktuální účiník: <b v-for="item in data.inverter" :key="item.index + 'L'"> {{ Math.round((item.activePower / item.apparentPower) * 1000) / 1000 }} [-] </b> <br />
                    </i>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <h4 class="text-center">cos &phi; (P) - Účiník závislý na činném výkonu</h4>
                      </v-col>

                      <v-col cols="12">
                        <template v-if="parameters != null">
                          <ApexScatterChartMixed
                            :chart="'E'"
                            :Smax="Smax"
                            :Pmax="Pmax"
                            :Qmax="Qmax"
                            :QPmax="QPmax"
                            :powerFactor="powerFactor"
                            :U1="data.grid.length > 0 ? data.grid[0].u : 0"
                            :U2="data.grid.length > 1 ? data.grid[1].u : 0"
                            :U3="data.grid.length > 2 ? data.grid[2].u : 0"
                            :P1="data.inverter.length > 0 ? data.inverter[0].activePower : 0"
                            :P2="data.inverter.length > 1 ? data.inverter[1].activePower : 0"
                            :P3="data.inverter.length > 2 ? data.inverter[2].activePower : 0"
                            :S1="data.inverter.length > 0 ? data.inverter[0].apparentPower : 0"
                            :S2="data.inverter.length > 1 ? data.inverter[1].apparentPower : 0"
                            :S3="data.inverter.length > 2 ? data.inverter[2].apparentPower : 0"
                            :directionP1="data.state.length > 0 ? data.state[0].i8QDirection : 0"
                            :directionP2="data.state.length > 1 ? data.state[1].i8QDirection : 0"
                            :directionP3="data.state.length > 2 ? data.state[2].i8QDirection : 0"
                            :PFCurveForCosPhi_PowerReponse_X1="PFCurveForCosPhi_PowerReponse_X1"
                            :PFCurveForCosPhi_PowerReponse_X2="PFCurveForCosPhi_PowerReponse_X2"
                            :dark="$vuetify.theme.dark"
                          />
                        </template>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <br />
            <br />
            <br />

            <v-row dense class="ma-1 rounded">
              <v-col cols="12" md="6" class="text-caption">
                <v-row>
                  <v-col cols="5" align="center">
                    <template v-if="onGridConfigBits.EN_Q_f_FixedQ === true">
                      <v-chip small color="green" outlined><b>Q=konst. - Funkce aktivována!</b> </v-chip>
                    </template>
                    <template v-else>
                      <v-chip small color="red" outlined><b> Q=konst. - Funkce není povolena!</b> </v-chip>
                    </template>
                  </v-col>
                  <v-col cols="7">
                    <i>
                      Jalový výkon: <b v-for="item in data.QLimits" :key="item.index + 'M'"> {{ item.fQFix }} VAr</b> <br />
                      Zpětná vazba: <b v-for="item in data.inverter" :key="item.index + 'N'">{{ item.reactivePower }} [VAr] </b> <br />
                      Nastavená hodnota: <b>{{ fixedQ1Value }} [VAr] {{ fixedQ2Value }} [VAr] {{ fixedQ3Value }} [VAr] </b>
                    </i>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="6" class="text-caption">
                <v-row>
                  <v-col cols="5" align="center">
                    <template v-if="onGridConfigBits.EN_Q_f_FixedPF === true">
                      <v-chip small color="green" outlined><b>cos &phi; = konst. - Funkce aktivována!</b> </v-chip>
                    </template>
                    <template v-else>
                      <v-chip small color="red" outlined><b> cos &phi; = konst - Funkce není povolena!</b> </v-chip>
                    </template>
                  </v-col>
                  <v-col cols="7">
                    <i>
                      Jalový výkon: <b v-for="item in data.QLimits" :key="item.index + 'O'"> {{ item.fQCosPhiFix }} VAr </b> <br />
                      Zpětná vazba: <b v-for="item in data.inverter" :key="item.index + 'P'"> {{ Math.round((item.activePower / item.apparentPower) * 1000) / 1000 }} [-] </b> <br />
                      Nastavená hodnota: <b>{{ fixedPFValue }} [-] </b>
                    </i>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item class="ma-2">
            <v-row class="ma-1">
              <v-col cols="12" class="ma-2 text-caption">
                <i>
                  Pro funkci <b> Q(U) </b> K limitaci jalového výkonu na nízkém činném výkonu by měli být konfigurovatelné dvě metody: <br /><br />
                  a) Dvě úrovně činného výkonu v rozmezí 0 až 100% <br />
                  b) Minimální cos &phi; v rozmezí 0-0.95 <br />
                </i>
                <br />
              </v-col>

              <v-col cols="12" class="text-caption">
                <v-row dense>
                  <v-col cols="12" md="6" align="center">
                    <v-row>
                      <v-col cols="12">
                        <template v-if="onGridConfigBits.EN_Q_f_U_TwoActivePowerLevels === true">
                          <v-chip small color="green" outlined><b>Q(U) - Aktivováno zapínání pomocí výkonostních úrovní</b> </v-chip>
                        </template>
                        <template v-else>
                          <v-chip small color="red" outlined><b>Q(U) - Deaktivováno zapínání pomocí výkonostních úrovní</b> </v-chip>
                        </template>
                      </v-col>

                      <v-col cols="12">
                        <v-row no-gutters>
                          <v-col cols="12">
                            <h4 class="text-center">Aktivace Q(U) pomocí dvou výkonostních úrovní</h4>
                          </v-col>

                          <v-col cols="12">
                            <template v-if="parameters != null">
                              <ApexScatterChartMixed
                                :chart="'F'"
                                :Smax="Smax"
                                :Pmax="Pmax"
                                :Qmax="Qmax"
                                :QPmax="QPmax"
                                :powerFactor="powerFactor"
                                :qfULockOut="ReactivePower_QfU_ActivePowerLevelLockOut"
                                :qfULockIn="ReactivePower_QfU_ActivePowerLevelLockIn"
                                :P1="data.inverter.length > 0 ? data.inverter[0].activePower : 0"
                                :P2="data.inverter.length > 1 ? data.inverter[1].activePower : 0"
                                :P3="data.inverter.length > 2 ? data.inverter[2].activePower : 0"
                                :dark="$vuetify.theme.dark"
                              />
                            </template>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" md="6" align="center">
                    <v-row>
                      <v-col cols="12">
                        <template v-if="onGridConfigBits.EN_Q_f_U_MinimalCosPhi === true">
                          <v-chip small color="green" outlined><b>Q(U) - Aktivován minimální učiník</b> </v-chip>
                        </template>
                        <template v-else>
                          <v-chip small color="red" outlined><b> Q(U) - Deaktivován minimální učiník</b> </v-chip>
                        </template>
                      </v-col>

                      <v-col cols="12">
                        Nastavený minimální účiník:<b> {{ ReactivePower_QfU_MinimalCosPhi }} </b>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="6" class="text-caption"> </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item class="ma-2">
            <v-row class="ma-2">
              <v-col cols="12" md="6" class="text-caption text-center">
                <h3>Střídač</h3>
                <i>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center" width="5%"><b>Fáze</b><br />[-]</th>
                          <th class="text-center" width="10%"><b>P</b><br />[W]</th>
                          <th class="text-center" width="10%"><b>Q</b><br />[VAr]</th>
                          <th class="text-center" width="10%"><b>S</b><br />[VA]</th>
                          <th class="text-center" width="5%"><b>U</b><br />[V]</th>
                          <th class="text-center" width="5%"><b>I</b><br />[A]</th>
                          <th class="text-center" width="5%"><b>f</b><br />[Hz]</th>
                          <th class="text-center" width="5%"><b>uhel</b><br />[°]</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in data.inverter" :key="item.index + 'Q'">
                          <td>{{ item.ph }}</td>
                          <td>{{ item.activePower }}</td>
                          <td>{{ item.reactivePower }}</td>
                          <td>{{ item.apparentPower }}</td>
                          <td>{{ item.u }}</td>
                          <td>{{ item.i }}</td>
                          <td>{{ item.f }}</td>
                          <td>{{ item.phi }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </i>
              </v-col>

              <v-col cols="12" md="6" class="text-caption text-center">
                <h3>Síť</h3>
                <i>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center" width="5%"><b>Fáze</b><br />[-]</th>
                          <th class="text-center" width="10%"><b>P</b><br />[W]</th>
                          <th class="text-center" width="10%"><b>Q</b><br />[VAr]</th>
                          <th class="text-center" width="10%"><b>S</b><br />[VA]</th>
                          <th class="text-center" width="5%"><b>U</b><br />[V]</th>
                          <th class="text-center" width="5%"><b>I</b><br />[A]</th>
                          <th class="text-center" width="5%"><b>f</b><br />[Hz]</th>
                          <th class="text-center" width="5%"><b>uhel</b><br />[°]</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in data.grid" :key="item.index + 'R'">
                          <td>{{ item.ph }}</td>
                          <td>{{ item.activePower }}</td>
                          <td>{{ item.reactivePower }}</td>
                          <td>{{ item.apparentPower }}</td>
                          <td>{{ item.u }}</td>
                          <td>{{ item.i }}</td>
                          <td>{{ item.f }}</td>
                          <td>{{ item.phi }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </i>
              </v-col>
            </v-row>

            <v-row class="ma-2">
              <v-col cols="12" class="text-caption text-center">
                <h3>Limity činného výkonu P[W]</h3>
                <i>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center" width="3%">Fáze<br />[-]</th>
                          <th class="text-center" width="5%">P<br />[W]</th>
                          <th class="text-center" width="5%">P(SoC)<br />[W]</th>
                          <th class="text-center" width="5%">P(U)<br />[W]</th>
                          <th class="text-center" width="5%">P(f<sub>Lower</sub>)<br />[W]</th>
                          <th class="text-center" width="5%">P(f<sub>Upper</sub>)<br />[W]</th>
                          <th class="text-center" width="5%">P(S<sub>max</sub>)<br />[W]</th>
                          <th class="text-center" width="5%">P(<sub>ZeroOverflows</sub>)<br />[W]</th>
                          <th class="text-center" width="5%">P(I<sub>max</sub>)<br />[W]</th>
                          <th class="text-center" width="5%">P(<sub>DRM</sub>)<br />[W]</th>
                          <th class="text-center" width="5%">P<sub>charge</sub>(<sub>DRM</sub>)<br />[W]</th>
                          <th class="text-center" width="5%">P<sub>charge</sub>(Available)<br />[W]</th>
                          <th class="text-center" width="5%">P<sub>charge</sub>(<sub>EliminateOverflow</sub>)<br />[W]</th>
                          <th class="text-center" width="5%">P<sub>charge</sub>(U)<br />[W]</th>

                          <th class="text-center" width="5%">P(<sub>MaxResPower</sub> )<br />[W]</th>
                          <th class="text-center" width="5%">P(<sub>PrefConsumption</sub>)<br />[W]</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in data.PLimits" :key="item.index + 'S'">
                          <td>{{ item.ph }}</td>
                          <td>{{ item.fP }}</td>
                          <td>{{ item.fPfSOC }}</td>
                          <td>{{ item.fPDischargefU }}</td>
                          <td>{{ item.fPfFrequencyLower }}</td>
                          <td>{{ item.fPfFrequencyUpper }}</td>
                          <td>{{ item.fPfS }}</td>
                          <td>{{ item.fPfZeroOverflows }}</td>
                          <td>{{ item.fPfImax }}</td>
                          <td>{{ item.fPfDRMDischarge }}</td>
                          <td>{{ item.fPfDRMCharge }}</td>
                          <td>{{ item.fPfChargeAvailable }}</td>
                          <td>{{ item.fPChargeEliminateOverflows }}</td>
                          <td>{{ item.fPChargefU }}</td>

                          <td>{{ item.fPfMaximumReservedPower == undefined ? "N/A" : item.fPfMaximumReservedPower }}</td>
                          <td>{{ item.fPfPrefConsumption == undefined ? "N/A" : item.fPfPrefConsumption }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </i>
              </v-col>
            </v-row>

            <v-row class="ma-2">
              <v-col cols="12" md="6" class="text-caption text-center">
                <h3>Požadavky jalového výkonu Q[VAr]</h3>
                <i>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center" width="3%">Fáze<br />[-]</th>
                          <th class="text-center" width="5%">Q<br />[VAr]</th>
                          <th class="text-center" width="5%">Q = konst.<br />[VAr]</th>
                          <th class="text-center" width="5%">Q(U)<br />[VAr]</th>
                          <th class="text-center" width="5%">cos &phi; = konst.<br />[VAr]</th>
                          <th class="text-center" width="5%">cos &phi;(P)<br />[VAr]</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in data.QLimits" :key="item.index + 'T'">
                          <td>{{ item.ph }}</td>
                          <td>{{ item.fQ }}</td>
                          <td>{{ item.fQFix }}</td>
                          <td>{{ item.fQfU }}</td>
                          <td>{{ item.fQCosPhiFix }}</td>
                          <td>{{ item.fQCosPhiP }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </i>
              </v-col>
            </v-row>

            <v-row class="ma-2">
              <v-col cols="12" md="8" class="text-caption text-center">
                <h3>Asymetrický stav jednotlivých fází</h3>
                <i>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center" width="3%">Fáze<br />[-]</th>
                          <th class="text-center" width="5%">Generování<br />[-]</th>
                          <th class="text-center" width="5%">Nabíjení<br />[-]</th>
                          <th class="text-center" width="5%">Standby<br />[-]</th>
                          <th class="text-center" width="15%">Vedení / Zpoždování fáze<br />[-]</th>
                          <th class="text-center" width="15%">Standby - Nízká baterie<br />[-]</th>
                          <th class="text-center" width="15%">Standby - Nízká spotřeba na fázi<br />[-]</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in data.state" :key="item.index + 'U'">
                          <td>{{ item.ph }}</td>
                          <td>{{ item.u8Sharing }}</td>
                          <td>{{ item.u8Charging }}</td>
                          <td>{{ item.u8GridOnly }}</td>
                          <td>{{ item.i8QDirection }}</td>
                          <td>{{ item.u8OutputDisabledLowBattery }}</td>
                          <td>{{ item.u8OutputDisabledMinimalConsumption }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </i>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs>
      </keep-alive>
    </template>
    <template v-else>
      <LoadingData />
    </template>
    <UpgradeCore />
  </div>
</template>

<script>
import UpgradeCore from "../../components/upgrade/UpgradeCore.vue";

import { mapState } from "vuex";
import LoadingData from "../../components/LoadingData.vue";

import ApexScatterChartMixed from "../../components/charts/apexcharts/ApexScatterChartMixed.vue";

import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "PPDS",
  components: {
    ApexScatterChartMixed,
    LoadingData,
    UpgradeCore,
  },
  data() {
    return {
      mobile: false,

      tabs: 0,

      timerPPDS: null,
      timerParameters: null,

      GridPresent: 0,

      parameters: null,

      nominalCurrent: 0,
      nominalVoltage: 0,
      nominalPower: 0,
      Pmax: 0,
      Smax: 0,
      Qmax: 0,
      QPmax: 0,

      frequencyMin: 0,
      frequencyMax: 0,

      ReactivePower_QfU_MinimalCosPhi: 0,
      ReactivePower_QfU_ActivePowerLevelLockIn: 0,
      ReactivePower_QfU_ActivePowerLevelLockOut: 0,
      PFCurveForCosPhi_PowerReponse_X1: 0,
      PFCurveForCosPhi_PowerReponse_X2: 0,
      powerFactor: 0,
      fixedPFValue: 0,

      fixedQ1Value: 0,
      fixedQ2Value: 0,
      fixedQ3Value: 0,

      y1: 0,
      y2: 0,
      y3: 0,
      y4: 0,
      v1: 0,
      v2: 0,
      v3: 0,
      v4: 0,
      v5: 0,
      v6: 0,
      v7: 0,
      activeMinimumPowerPU: 0,

      P_HF_ThresholdFreq: 0,
      P_HF_StopFreq: 0,
      P_HF_Gradient: 0,
      P_HF_Delay: 0,
      P_HF_StopFreq2: 0,
      P_HF_DeactivationTime: 0,

      P_LF_ThresholdFreq: 0,
      P_LF_StopFreq: 0,
      P_LF_Gradient: 0,
      P_LF_Delay: 0,

      onGridConfigBits: {},

      data: null,

      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    };
  },
  created() {
    this.getBreakpoints();

    this.getPPDS();
    this.getParameters();
  },
  mounted() {
    this.pollPPDS();
    this.pollParameters();

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    onResize() {
      this.getBreakpoints();
    },
    getBreakpoints() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < 768) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
    pollPPDS() {
      this.timerPPDS = setInterval(() => {
        this.getPPDS();
      }, 2000);
    },
    pollParameters() {
      this.timerParameters = setInterval(() => {
        this.getParameters();
      }, 20000);
    },
    getPPDS() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("ppds"), null, null, "GET")
        .then((data) => {
          this.data = data;

          let l = 0;

          if ("u32Uptime" in this.data.synchronization) {
            l = this.data.synchronization.u32Uptime - this.data.synchronization.u32GridPresent;
          } else {
            l = this.data.synchronization.u32GridPresent;
          }

          if (l < 0) {
            l = 0; // Ignore aliasing when, present come sooner than uptime
          } else if (l < 3) {
            l = 0; // Start calc from 3, cause of antialiasing
          }

          this.GridPresent = l;
        })
        .catch((error) => {
          this.data = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    getParameters() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("parameters"), null, null, "GET")
        .then((data) => {
          if (this.timeoutParametersTimer != null) {
            clearInterval(this.timeoutParametersTimer);
          }

          this.parameters = data;

          for (let i = 0; i < this.parameters.units.length; i++) {
            if (this.parameters.units[i].type == "EINV1H1" || this.parameters.units[i].type == "EINV1H0" || this.parameters.units[i].type == "EINV3H0") {
              for (let j = 0; j < this.parameters.units[i].parameters.length; j++) {
                if (this.parameters.units[i].parameters[j].name == "ReactivePower_QfU_Y1") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.y1 = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "ReactivePower_QfU_Y2") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.y2 = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "ReactivePower_QfU_Y3") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.y3 = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "ReactivePower_QfU_Y4") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.y4 = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "V1") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.v1 = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "V2") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.v2 = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "V3") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.v3 = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "V4") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.v4 = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "V5") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.v5 = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "V6") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.v6 = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "V7") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.v7 = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "ActiveMinimumPowerPU") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.activeMinimumPowerPU = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "PowerFactor") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.powerFactor = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "ReactivePower_FixedPFValue") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.fixedPFValue = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "ReactivePower_ReactivePowerModeValue") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.fixedQ1Value = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "ReactivePower_ReactivePower2ModeValue") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.fixedQ2Value = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "ReactivePower_ReactivePower3ModeValue") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.fixedQ3Value = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "ReactivePower_PFCurveForCosPhi_PowerReponse_X1") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.PFCurveForCosPhi_PowerReponse_X1 = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "ReactivePower_PFCurveForCosPhi_PowerReponse_X2") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.PFCurveForCosPhi_PowerReponse_X2 = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "ReactivePower_QfU_MinimalCosPhi") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.ReactivePower_QfU_MinimalCosPhi = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "ReactivePower_QfU_ActivePowerLevelLockIn") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.ReactivePower_QfU_ActivePowerLevelLockIn = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "ReactivePower_QfU_ActivePowerLevelLockOut") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.ReactivePower_QfU_ActivePowerLevelLockOut = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "NominalCurrent") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.nominalCurrent = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "NominalVoltage") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.nominalVoltage = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "NominalPower") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.nominalPower = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "FrequencyMin") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.frequencyMin = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "FrequencyMax") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.frequencyMax = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "OverflowsThresholdFrequency") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.P_HF_ThresholdFreq = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "OverflowsStopFrequency") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.P_HF_StopFreq = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "OverflowsGradient") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.P_HF_Gradient = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "FrequencyResponseOfActivePAtOverFrequencyAdditionalDelay") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.P_HF_Delay = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "FrequencyResponseOfActivePAtOverFrequencyStopFrequency2") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.P_HF_StopFreq2 = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "FrequencyResponseOfActivePAtOverFrequencyDeactivationTime") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.P_HF_DeactivationTime = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "FrequencyResponseOfActivePAtUnderFrequencyThresholdFrequency") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.P_LF_ThresholdFreq = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "FrequencyResponseOfActivePAtUnderFrequencyStopFrequency") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.P_LF_StopFreq = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "FrequencyResponseOfActivePAtUnderFrequencyGradient") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.P_LF_Gradient = this.parameters.units[i].parameters[j].value;
                  }
                }
                if (this.parameters.units[i].parameters[j].name == "FrequencyResponseOfActivePAtUnderFrequencyAdditionalDelay") {
                  if (this.parameters.units[i].parameters[j].value != 0) {
                    this.P_LF_Delay = this.parameters.units[i].parameters[j].value;
                  }
                }

                if (this.parameters.units[i].parameters[j].name == "OnGridConfigBits") {
                  for (let k = 0; k < this.parameters.units[i].parameters[j].bits.length; k++) {
                    if (this.parameters.units[i].parameters[j].bits[k].name == "EN_P_f_UUpper") {
                      this.onGridConfigBits.EN_P_f_UUpper = this.parameters.units[i].parameters[j].bits[k].value;
                    }
                    if (this.parameters.units[i].parameters[j].bits[k].name == "EN_P_f_ULowerCharging") {
                      this.onGridConfigBits.EN_P_f_ULowerCharging = this.parameters.units[i].parameters[j].bits[k].value;
                    }
                    if (this.parameters.units[i].parameters[j].bits[k].name == "EN_Q_f_U") {
                      this.onGridConfigBits.EN_Q_f_U = this.parameters.units[i].parameters[j].bits[k].value;
                    }
                    if (this.parameters.units[i].parameters[j].bits[k].name == "EN_Q_f_FixedPF") {
                      this.onGridConfigBits.EN_Q_f_FixedPF = this.parameters.units[i].parameters[j].bits[k].value;
                    }
                    if (this.parameters.units[i].parameters[j].bits[k].name == "EN_Q_f_FixedQ") {
                      this.onGridConfigBits.EN_Q_f_FixedQ = this.parameters.units[i].parameters[j].bits[k].value;
                    }
                    if (this.parameters.units[i].parameters[j].bits[k].name == "EN_Q_f_AdaptivePF") {
                      this.onGridConfigBits.EN_Q_f_AdaptivePF = this.parameters.units[i].parameters[j].bits[k].value;
                    }
                    if (this.parameters.units[i].parameters[j].bits[k].name == "EN_P_f_f_Gradient") {
                      this.onGridConfigBits.EN_P_f_f_Gradient = this.parameters.units[i].parameters[j].bits[k].value;
                    }
                    if (this.parameters.units[i].parameters[j].bits[k].name == "EN_Q_f_U_MinimalCosPhi") {
                      this.onGridConfigBits.EN_Q_f_U_MinimalCosPhi = this.parameters.units[i].parameters[j].bits[k].value;
                    }
                    if (this.parameters.units[i].parameters[j].bits[k].name == "EN_Q_f_U_TwoActivePowerLevels") {
                      this.onGridConfigBits.EN_Q_f_U_TwoActivePowerLevels = this.parameters.units[i].parameters[j].bits[k].value;
                    }
                    if (this.parameters.units[i].parameters[j].bits[k].name == "EN_P_f_fUpper") {
                      this.onGridConfigBits.EN_P_f_fUpper = this.parameters.units[i].parameters[j].bits[k].value;
                    }
                    if (this.parameters.units[i].parameters[j].bits[k].name == "EN_P_f_fLower") {
                      this.onGridConfigBits.EN_P_f_fLower = this.parameters.units[i].parameters[j].bits[k].value;
                    }
                  }
                }
              }
            }
          }

          this.Smax = Math.round(this.nominalPower * 1000) / 1000;
          this.Pmax = Math.round(this.Smax * this.powerFactor * 1000) / 1000;
          this.Qmax = Math.round(Math.sqrt(this.Smax * this.Smax - this.Pmax * this.Pmax) * 1000) / 1000;
          this.QPmax = Math.round((this.Qmax / this.Pmax) * 1000) / 1000;
        })
        .catch((error) => {
          if (this.timeoutParametersTimer == null) {
            this.timeoutParametersTimer = setInterval(() => {
              this.getParameters();
            }, 1500);
          }

          this.parameters = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.timerPPDS);
    clearInterval(this.timerParameters);

    window.removeEventListener("resize", this.onResize);
  },
  destroyed() {},
};
</script>

<style scoped></style>
